const tabifoto = {
  tabifoto: {
    nav: {
      home: "Home",
      booking: "Book Now",
      philosophy: "Our Story",
      language: "Language",
      apply: "Become a Photographer",
    },
    hero: {
      headline_1: "Capture Your Journey",
      headline_2: "in Japan",
      subheadline: "Connect with independent local photographers for authentic storytelling",
      cta: "Begin Your Story",
    },
    cities: {
      section_title: "Choose Your Destination",
      section_sub: "Select a city to explore available photographers",
      kyoto: "Kyoto",
      osaka: "Osaka",
      tokyo: "Tokyo",
      coming_soon: "Coming Soon",
    },
    storytelling: {
      label: "Our Philosophy",
      quote: "Photography is not about places. It's about the moments between.",
      body: "We believe every journey deserves to be remembered with honesty and beauty. TaBiFoTo connects you with independent local photographers who understand the soul of Japan.",
    },
    services: {
      section_title: "What We Offer",
      section_sub: "Pure photography experiences — nothing bundled, nothing extra",
      photography_8h: {
        title: "8-Hour Photography",
        desc: "A full day alongside a local photographer capturing your authentic moments across the city.",
        feature_1: "8 hours of dedicated coverage",
        feature_2: "100+ edited digital photos",
        feature_3: "Private online gallery",
      },
      photography_video: {
        title: "Photography + Short Video",
        desc: "Everything in the photography package, plus a cinematic short film of your day.",
        feature_1: "All photography package benefits",
        feature_2: "60–90 second cinematic video",
        feature_3: "Soundtrack & color grading included",
      },
      from_price: "Inquire for pricing",
    },
    booking: {
      title: "Book Your Photography Experience",
      step_1: "Select City",
      step_2: "Select Service",
      step_3: "Select Date",
      step_4: "Add-ons",
      step_5: "Checkout",
      select_city: "Where will your story unfold?",
      select_service: "Choose your experience",
      select_date: "When is your special day?",
      select_addons: "Optional Enhancements",
      addons_note: "These are external partner services — not provided by TaBiFoTo",
      kimono_title: "Kimono Rental",
      kimono_desc: "Dress in a traditional kimono for your photoshoot. Arranged through local kimono partners.",
      makeup_title: "Hair & Makeup",
      makeup_desc: "Professional styling before your session. Arranged through local beauty partners.",
      external_partner: "External partner",
      checkout_title: "Confirm Your Booking",
      your_name: "Your Name",
      your_email: "Email Address",
      your_phone: "Phone Number",
      special_requests: "Special Requests (optional)",
      order_summary: "Order Summary",
      city_label: "City",
      service_label: "Service",
      date_label: "Date",
      addons_label: "Add-ons",
      none: "None",
      confirm_booking: "Confirm Booking",
      booking_confirmed: "Booking Request Sent",
      booking_confirmed_desc: "We've received your request. Our team will confirm your photographer within 24 hours.",
      next: "Continue",
      back: "Back",
      select_date_placeholder: "Select a date",
      morning: "Morning",
      afternoon: "Afternoon",
      full_day: "Full Day",
      legal_loading: "Loading terms...",
      legal_section_title: "Terms Confirmation",
      legal_section_sub: "Please read and confirm the following before continuing",
      legal_agree_prefix: "I agree to the",
      legal_version_prefix: "Version",
      legal_effective_prefix: "Effective",
      legal_view_content: "Read Terms",
      legal_hide_content: "Collapse",
      legal_required: "Required",
      legal_optional: "Optional",
      legal_all_required_msg: "Please accept all required terms to continue",
      legal_must_accept: "You must accept all required terms before completing your booking",
      field_required: "Required",
      field_email_invalid: "Please enter a valid email address",
      photographer_preference_label: "Photographer Comfort Preference (optional)",
      photographer_preference_none: "No preference",
      photographer_preference_female_preferred: "Prefer female photographer",
      photographer_preference_note: "This preference is used as a matching reference only and does not restrict photographer availability.",
    },
    product: {
      photography_8h: "8-Hour Photography",
      photography_video: "Photography + Video",
    },
    philosophy: {
      hero_title: "Photography, Not Packaging",
      hero_sub: "We exist to connect people with authentic storytellers — not to sell tours.",
      section_1_title: "What We Are",
      section_1_body: "TaBiFoTo is a booking platform that connects travelers with independent local photographers across Japan. We are not a travel agency. We do not sell tours, packages, or experiences bundled with transportation or accommodation.",
      section_2_title: "Independent Photographers",
      section_2_body: "Every photographer on our platform is an independent contractor who brings their own creative vision, local knowledge, and professional skill. We do not employ photographers — we amplify them.",
      section_3_title: "What We Sell",
      section_3_body: "We sell time with a photographer. One skill. One craft. Preserved honestly and beautifully. No upsells, no bundles, no confusion about what you're getting.",
      section_4_title: "The Moment, Not the Monument",
      section_4_body: "Japan has no shortage of iconic locations. What's rare is someone who knows how to find the quiet light between crowded streets — and that's exactly who our photographers are.",
      values_title: "Our Values",
      value_1_title: "Authenticity",
      value_1_body: "Real photographers, real moments, real memories.",
      value_2_title: "Independence",
      value_2_body: "Every photographer owns their craft and their creative freedom.",
      value_3_title: "Simplicity",
      value_3_body: "One service. Photography. Done beautifully.",
      cta_title: "Ready to Create Memories?",
      cta_body: "Start your booking and we'll connect you with the perfect photographer.",
      cta_button: "Book Your Photographer",
    },
    footer: {
      tagline: "Authentic photography experiences across Japan",
      links_explore: "Explore",
      link_home: "Home",
      link_booking: "Book Now",
      link_philosophy: "Our Story",
      links_info: "Information",
      link_faq: "FAQ",
      link_contact: "Contact",
      link_terms: "Terms",
      link_apply: "Become a Photographer",
      newsletter_label: "Stay Inspired",
      newsletter_placeholder: "Your email address",
      newsletter_submit: "Subscribe",
      copyright: "© 2024 TaBiFoTo. All rights reserved.",
    },
    apply: {
      page_title: "Become a Photographer",
      page_sub: "Closed Beta Recruitment · We\'re looking for independent photographers across Japan",
      philosophy_title: "Our Collaboration Philosophy",
      philosophy_body: "TaBiFoTo is not a tourism platform — we\'re the bridge between photographers and travelers. We respect each photographer\'s creative independence and handle bookings, communication, and admin so you can focus on what you do best: creating.",
      philosophy_point_1: "Full creative freedom for photographers",
      philosophy_point_2: "Platform handles bookings, communication & admin",
      philosophy_point_3: "Transparent revenue sharing, no hidden fees",
      requirements_title: "Requirements",
      req_language_title: "Language Skills",
      req_language_body: "Ability to serve clients in English, Chinese, or Japanese (at least one). Communication ability matters more than fluency.",
      req_cities_title: "Service Cities",
      req_cities_body: "Currently available: Kyoto, Osaka, Tokyo. More cities coming soon.",
      req_portfolio_title: "Portfolio",
      req_portfolio_body: "Please provide a link to your portfolio (Instagram, personal website, Behance, etc.). No specific style requirement — authentic and heartfelt work is what we look for.",
      form_title: "Application Form",
      form_note: "During the closed beta, applications will be reviewed manually. We\'ll reach out directly upon acceptance.",
      field_name: "Full Name",
      field_name_placeholder: "Your full name",
      field_email: "Email Address",
      field_email_placeholder: "your@email.com",
      field_line_or_contact: "LINE / Other Contact",
      field_line_or_contact_placeholder: "LINE ID or other contact method",
      field_service_cities: "Service Cities",
      field_languages: "Languages",
      field_portfolio_url: "Portfolio URL",
      field_portfolio_url_placeholder: "https://instagram.com/...",
      field_profile_image_url: "Profile Photo URL (optional)",
      field_profile_image_url_placeholder: "https://...",
      field_short_bio: "Short Bio",
      field_short_bio_placeholder: "Briefly describe your photography style and experience (under 200 words)",
      city_kyoto: "Kyoto",
      city_osaka: "Osaka",
      city_tokyo: "Tokyo",
      lang_zh: "Chinese",
      lang_en: "English",
      lang_ja: "Japanese",
      submit: "Submit Application",
      submitting: "Submitting...",
      success_title: "Application Received",
      success_body: "Thank you for applying! We\'ll review your application and reach out by email.",
      error_required: "This field is required",
      error_email: "Please enter a valid email address",
      error_city: "Please select at least one city",
      error_language: "Please select at least one language",
      error_submit: "Submission failed. Please try again.",
    },
    admin: {
      orders: "Orders",
      photographers: "Photographers",
      assignments: "Assignments",
    },
  },
};

export default tabifoto;
